import { useMemo } from 'react';

import { SimpleStatistics } from '#entities';
import { getMsUntilNextSecond } from '#shared';

import { usePollingQuery } from '../../usePollingQuery';
import { useGetSimpleStatisticsQuery } from '../simpleStatistics.api';

import type { PollingQueryResult } from '../types';

const TARGET_SECOND = 5;

const getSimpleStatisticsDelay = () => getMsUntilNextSecond(TARGET_SECOND);

export const useQuerySimpleStatistics =
  (): PollingQueryResult<SimpleStatistics | null> => {
    const queryResult = useGetSimpleStatisticsQuery(undefined, {
      pollingInterval: 0,
    });

    const pollingResult = usePollingQuery(queryResult, {
      getDelay: getSimpleStatisticsDelay,
    });

    return useMemo(
      () => ({
        data: pollingResult.data?.data ?? null,
        generatedAt: pollingResult.data?.generatedAt ?? null,
        // Not a list payload — the stale-while-empty net (TSMED-1482) does not
        // apply here.
        isStale: false,
        validation: null, // TODO: add validation when schema validation is added
        isLoading: pollingResult.isLoading,
        isFetching: pollingResult.isFetching,
        isError: pollingResult.isError,
        error: pollingResult.error,
        lastSentTime: pollingResult.lastSentTime,
        lastReceiveTime: pollingResult.lastReceiveTime,
      }),
      [pollingResult],
    );
  };
